import { Product, Variant, VariantGroup } from "../../types/types";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";

export function promotionalMessagesToShow(
  product: Product,
  selectedVariant: Variant,
  isVariantSelected: boolean,
  showSaveLabels: boolean,
  selectedVariantGroup?: VariantGroup,
) {
  const isPromotionalMessage = (
    message: NonPromotionalMessage | PromotionalMessage,
  ): message is PromotionalMessage => {
    return (message as PromotionalMessage).promotionGroup !== undefined;
  };

  const variantGroupPromotionalMessaging =
    selectedVariantGroup && selectedVariantGroup.messaging
      ? selectedVariantGroup.messaging?.filter<PromotionalMessage>(
          isPromotionalMessage,
        )
      : [];

  const variantPromotionalMessaging = selectedVariant.messaging
    ? selectedVariant.messaging.filter<PromotionalMessage>(isPromotionalMessage)
    : [];

  const productPromotionalMessaging = product.messaging
    ? product.messaging.filter<PromotionalMessage>(isPromotionalMessage)
    : [];

  const hasVariantLevelMessaging =
    isVariantSelected && variantPromotionalMessaging.length;

  const hasVariantGroupLevelMessaging =
    selectedVariantGroup && variantGroupPromotionalMessaging?.length;

  if (hasVariantLevelMessaging || (isVariantSelected && showSaveLabels))
    return variantPromotionalMessaging;
  else if (
    hasVariantGroupLevelMessaging ||
    (selectedVariantGroup && showSaveLabels)
  )
    return variantGroupPromotionalMessaging;
  else return productPromotionalMessaging;
}
